import type { User } from '~/types/auth.model'
import type { UseStateType } from '~/types/utils/use-state-type'

// This is used to extract the right types from Nuxt useState
type Types = UseStateType<User | null>

/**
 * A type-safe wrapper around `useState`
 */
export const useUserState = (init: Types['firstParam'] = undefined): Types['return'] =>
  useState<Types['state']>('user', init)

export function setUserState(user: User | null): void {
  const userState = useUserState()
  userState.value = user
}
